import { SvgIcon } from '@mui/material'
import type { SvgIconProps } from '@mui/material/SvgIcon'

export const UnderObservationDoubleIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} viewBox="0 0 82 82" fill="none" >
            <circle cx="41" cy="41" r="29" stroke="#FF3B2F" strokeWidth="4" />
            <circle cx="41" cy="41" r="17" stroke="#FF3B2F" strokeWidth="4" />
            <circle cx="41" cy="41" r="7" fill="#FF3B2F" />
            <line x1="41" y1="80" x2="41" y2="2" stroke="#FF3B2F" strokeWidth="4" strokeLinecap="round" />
            <line x1="2" y1="41" x2="80" y2="41" stroke="#FF3B2F" strokeWidth="4" strokeLinecap="round" />
        </SvgIcon>
  )
}
